export default __webpack_public_path__ + "static/media/highlight-1.2650c7e4.jpg";